module.exports = __webpack_public_path__ + "img/Firewall.398439d 1.b7485a0.svg";